<template>
<div>
  <breadcrumb :items="[{ text: 'Ofertas coletivas', active: true }]" />
  <b-alert variant="danger" show v-if="error">{{ error }}</b-alert>
  <loading :loading="!offers && !error" msg="Carregando lista de ofertas" />
  <no-item :list="offers" />
  <div v-if="offers && offers.length">
    <b-table stacked="lg" :fields="table_fields" :items="offers" :sort-by="'name'" :filter="filters.search">
      <template slot="thumb" slot-scope="data">
        <router-link :to="'/editar-oferta-coletiva/' + data.item._id" class="product_td">
          <product-image :product="data.item.offer.product_variation" :product_variation="data.item.offer.product_variation" />
        </router-link>
      </template>
      <template slot="offer" slot-scope="data">
        <router-link :to="'/editar-oferta-coletiva/' + data.item._id" class="product_td">
          {{ data.value.product_variation.name }}
        </router-link>
      </template>
      <template slot="delivery_destination" slot-scope="data">
        {{ data.value[0] }}
        <br />
        {{ invoiceIssuer(data.item.invoice_issuer) }}
      </template>
      <template slot="address" slot-scope="data">
        <small v-if="data.value">{{data.value.description}}</small>
      </template>
      <template slot="final_price" slot-scope="data">
        {{ data.value | moeda }}
      </template>
      <template slot="qtd" slot-scope="data">
        {{ data.value }} unidades
      </template>
      <template slot="actions" slot-scope="data">
        <div class="btn-group btn-group-sm">
          <router-link :to="'/editar-oferta-coletiva/' + data.item._id" class="btn btn-primary">
            <i class="fa fa-pencil"></i>
          </router-link>
          <a @click="remove(data.item._id)" class="btn btn-secondary">
            <i class="fa fa-close"></i>
          </a>
        </div>
      </template>
    </b-table>
  </div>
</div>
</template>
<script>
import axios from "axios";
import Loading from "@/components/Loading";
import NoItem from "@/components/NoItem";
import ProductImage from "@/components/ProductImage";

export default {
  name: "CollectiveOffers",

  data() {
    return {
      filters: {
        search: null,
      },
      table_fields: [
        {
          key: 'thumb',
          label: '',
          class: "td-logo",
        },
        {
          key: "offer",
          label: "Oferta",
          sortable: true,
        },
        {
          key: "address",
          label: "Origem do Envio",
          sortable: true,
        },
        {
          key: "delivery_destination",
          label: "Destino do envio",
          sortable: true,
        },
        {
          key: "final_price",
          label: "Preço final",
          sortable: true,
        },
        {
          key: "qtd",
          label: "Disponível",
          sortable: true,
        },
        {
          key: "minimum_order",
          label: "Pedido mínimo",
          sortable: true,
        },
        {
          key: "actions",
          label: "",
          class: "td-actions",
        },
      ],
      offers: null,
    };
  },

  created() {
    this.list();
    this.table_fields.push({
      key: "actions",
      label: "",
      class: "td-actions",
    });
  },

  methods: {
    async list() {
      axios
        .get("collective_offers")
        .then((response) => {
          this.offers = response.data;
        })
        .catch(this.showError);
    },
    remove(id) {
      if (confirm("Tem certeza que deseja excluír?")) {
        axios
          .delete("collective_offers/" + id)
          .then(() => {
            this.list();
          })
          .catch(this.showError);
      }
    },
  },
  components: {
    Loading,
    NoItem,
    ProductImage,
  },
};
</script>
